module.exports = __webpack_public_path__ + "static/img/gzh.51015e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gzh.jpg
// module id = Tla2
// module chunks = 0